import { useAuthStore } from "@/stores/authStore";

function apply(el, allowed) {
  if (!allowed) {
    el.classList.add("d-none");          // Bootstrap uses !important ✅
    el.setAttribute("data-hidden-by", "v-can");
    el.setAttribute("aria-hidden", "true");
  } else {
    el.classList.remove("d-none");
    el.removeAttribute("data-hidden-by");
    el.removeAttribute("aria-hidden");
  }
}

export default {
  mounted(el, binding) {
    const auth = useAuthStore();
    apply(el, auth.can(binding.value));
  },
  updated(el, binding) {
    const auth = useAuthStore();
    apply(el, auth.can(binding.value));
  },
};
